import { MenuItem, TextField } from "@mui/material";
import { PropValueLine } from "../../common/PropValueLine";
import { WorldRenderer } from "../../WorldRenderer";
import { LightType, LightVisual } from "../../../visuals/LightVisual";

export function LightProps({ wr, light, onUpdate }: { 
  wr: WorldRenderer, 
  light: LightVisual,
  onUpdate: (light:Partial<LightVisual>)=>void
}) {
  return (
    <>
      <PropValueLine label='Type' value={
        <TextField
          fullWidth
          value={light.lightType}
          variant="standard"
          size="small"
          select
          onChange={(e) => {
            onUpdate({ lightType: e.target.value as LightType });
          }}
          >
          {Object.values(LightType).map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
          </TextField>
      } />
      <PropValueLine label='Intensity' value={
        <TextField
          fullWidth
          type="number"
          value={light.intensity}
          variant="standard"
          size="small"
          onChange={(e) => {
            onUpdate({ intensity: parseFloat(e.target.value) });
          }}
        />
      } />
    </>
  );
} 